import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingSpinner',
  props: {
    size: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loader", {'small': __props.size=='small', 'medium': !__props.size || __props.size=='medium', 'large': __props.size=='large'}])
  }, null, 2))
}
}

})